import { CommonTranslationKey } from '@/utils/localisation'

// Enum value is the verbatim text sent to the cancellation endpoint.
export enum CancellationReason {
  CargoNotReady = 'Cargo not ready',
  Price = 'Price',
  FalseBooking = 'False Booking',
  ServiceIssue = 'Service Issue (departure delays or long transit times)',
  Other = 'Other (pls provide the reason)',
}

export const CANCELLATION_REASON_LABEL_KEYS: Record<CancellationReason, CommonTranslationKey> = {
  [CancellationReason.CargoNotReady]: 'notifications.cancel_shipment.reason.options.cargo_not_ready',
  [CancellationReason.Price]: 'notifications.cancel_shipment.reason.options.price',
  [CancellationReason.FalseBooking]: 'notifications.cancel_shipment.reason.options.false_booking',
  [CancellationReason.ServiceIssue]: 'notifications.cancel_shipment.reason.options.service_issue',
  [CancellationReason.Other]: 'notifications.cancel_shipment.reason.options.other',
}
